module.exports = __webpack_public_path__ + "img/ctrl-magic-dagger-stub-0.9c113541.svg";